<vwui-header>
    <h2 a11yPageTitleLevel="1">{{ "PAGE_RISK_LIBRARY.title" | translate}}</h2>
</vwui-header>

<vwui-spinner *ngIf="loadingSpinnerService.isSpinnerVisible()"></vwui-spinner>

<app-library-mgmt *ngIf="!loadingSpinnerService.isSpinnerVisible()" [library]="riskLibrary" [companyTypeId]="companyTypeId">
</app-library-mgmt>
